import { useEffect } from 'react'
import { useOutOfStorageSpaceModal } from './components/index'
import { useShowOutOfStorageSpaceModal } from './hooks/useShowOutOfStorageSpaceModal'

export function OutOfStorageSpace() {
  const { isStorageExceeded } = useShowOutOfStorageSpaceModal()

  const { show: showOutOfStorageSpaceModal, Modal: OutOfStorageSpaceModal } =
    useOutOfStorageSpaceModal()

  useEffect(() => {
    if (isStorageExceeded) {
      showOutOfStorageSpaceModal()
    }
  }, [isStorageExceeded, showOutOfStorageSpaceModal])

  return <OutOfStorageSpaceModal />
}
